
import React, { useEffect, useRef, useState } from 'react';
import { Marker, Popup, Polygon } from 'react-leaflet';
import './styleFilter.css';
import { CONST_CANTON, CONST_HIGHWAY, icon100pabKtv, icon3kKtv, iconHouse, iconHouseAct } from '../Constants/ConstantsOptics';
import 'leaflet.markercluster';
import DialogNodeDescroption from '../Dialog/DialogNode/DialogNodeDescroption';
import { groupMarkersByCanton, groupMarkersByVetka, getPolygonPoints } from './GroupMarkersPolygon';
import { SERVICE_HOUSE_URL } from '../OpticApiConfig';
import L from 'leaflet';
import SwitchMarkerOpticMap from '../Markers/SwitchMarkerOpticMap';



const GetSwitchesMapLocation = ({
  switchesData, layersVisibility, isLineDrawing, icon100pab, iconKp, icon3k, icon30k, iconSummit, mapRef, highwayTerritory, cantonTerritory, showPolygonsArea, showPolygonsCanton,
  fobMarker, ponBoxMarker, pillarMarker, manholeMarker, couplingMarker, housesData, user, cantonRefresh, role, showPonLayer, showKtvLayer, showHouses,
  cantonFobRefresh, cantonPonBoxRefresh, highwayRefresh, ktvAmplifierData, cantonRefreshNode, showHousesActivatedPassive}) => {
    


  const cantonPolygonColor = '#c9c9df'; 
  const cantonPolygonsRef = useRef([]);
  const areaPolygonsRef = useRef([]);
  const [zoomLevel, setZoomLevel] = useState(null);
  const [openModalNode, setOpenModalNode] = useState(null); 
  const [openModalNodeEnt, setOpenModalNodeEnt] = useState(null);
  const [zoomHouse, setZoomHouse] = useState(null);
  const isZoomHouse = zoomHouse > 15;
  const markersByVetka = groupMarkersByVetka(housesData);
  const markersByCanton = groupMarkersByCanton(switchesData);
  const polygonPoints = getPolygonPoints(housesData, 20); // 20 — буфер в метрах

  // const markersByVetka = groupMarkersByVetka(switchesData);
  // const markersByCanton = groupMarkersByCanton(switchesData);
  // const polygonPoints = getPolygonPoints(switchesData, 20); // 20 — буфер в метрах

  // const { sw, hous } = housesData.reduce((acc, house) => {
  //   if (house.rank !== null) {
  //     acc.sw.push(house); // Добавляем в массив sw
  //   } else {
  //     acc.hous.push(house); // Добавляем в массив hous
  //   }
  //   return acc;
  // }, { sw: [], hous: [] }); // Начальные значения для аккумулятора
  
  // console.log('Свитчи (rank !== null):', sw);
  // console.log('Дома (rank === null):', hous);
  // const markersByVetka = groupMarkersByVetka(hous);
  // const markersByCanton = groupMarkersByCanton(sw);
  // const polygonPoints = getPolygonPoints(hous, 20); // 20 — буфер в метрах

 
// Фильтрация объектов по hid с выбором максимального entrance
const uniqueHouses = Object.values(
  housesData.reduce((acc, house) => {
    if (!acc[house.hid] || acc[house.hid].entrance < house.entrance) {
      acc[house.hid] = house; // Сохраняем объект, если это первый или с большим entrance
    }
    return acc;
  }, {})
);


  useEffect(() => {
    cantonPolygonsRef.current.forEach(polygon => {
      if (polygon) {
        polygon.setStyle({
          fillOpacity: showPolygonsCanton ? 0.2 : 0,
          opacity: showPolygonsCanton ? 0.6 : 0,
        });
      }
    });

    areaPolygonsRef.current.forEach(polygon => {
      if (polygon) {
        polygon.setStyle({
          fillOpacity: showPolygonsArea ? 0.2 : 0,
          opacity: showPolygonsArea ? 0.6 : 0,
        });
      }
    });
  }, [showPolygonsCanton, showPolygonsArea]);

  useEffect(() => {
    const handleZoomChange = () => {
      if (mapRef.current) { 
        const newZoom = mapRef.current.getZoom();
        setZoomLevel(newZoom);
        setZoomHouse(newZoom);
      }
    };

    if (mapRef.current) { 
      const map = mapRef.current;
      setZoomLevel(map.getZoom()); 
      map.on('zoomend', handleZoomChange); 
      return () => {
        map.off('zoomend', handleZoomChange);
      };
    }
  }, [mapRef]);

// DIALOG NODE


const handleOpenModal = (hid, entrance) => {
  setOpenModalNode(hid); // Открыть модальное окно для конкретного маркера
  setOpenModalNodeEnt(entrance);
};

const handleCloseModal = () => {
  setOpenModalNode(null); // Закрыть все модальные окна
  setOpenModalNodeEnt(null);
};




  return (
    
    <>

 {cantonTerritory &&
      Object.keys(markersByCanton).map((canton, cantonIndex) => {
        const coordinates = markersByCanton[canton];
        const polygonPoints = getPolygonPoints(coordinates);

        return (
          <React.Fragment key={cantonIndex}>
            {polygonPoints && (
              <Polygon
                ref={(el) => (cantonPolygonsRef.current[cantonIndex] = el)}
                positions={polygonPoints}
                color={cantonPolygonColor}
                fillOpacity={showPolygonsCanton ? 0.2 : 0}
                opacity={showPolygonsCanton ? 0.6 : 0}
              />
            )}


          {coordinates.map((coordinate, index) => (
            <SwitchMarkerOpticMap
              key={index}
              coordinate={coordinate}
              coordinates={coordinates}
              zoomLevel={zoomLevel}
              layersVisibility={layersVisibility}
              showPonLayer={showPonLayer}
              showKtvLayer={showKtvLayer}
              ktvAmplifierData={ktvAmplifierData}
              isLineDrawing={isLineDrawing}
              openModalNode={openModalNode}
              openModalNodeEnt={openModalNodeEnt}
              handleOpenModal={handleOpenModal}
              handleCloseModal={handleCloseModal}
              user={user}
              cantonRefreshNode={cantonRefreshNode}
              role={role}
              CONST_CANTON={CONST_CANTON}
              cantonFobRefresh={cantonFobRefresh}
              cantonPonBoxRefresh={cantonPonBoxRefresh}
              icon3kKtv={icon3kKtv}
              icon100pab={icon100pab}
              icon3k={icon3k}
              iconKp={iconKp}
              icon30k={icon30k}
              iconSummit={iconSummit}
              DialogNodeDescroption={DialogNodeDescroption}
            />
          ))}  

            

      {/* {coordinates.map((coordinate, index) => {
        const duplicateCoordinates = coordinates.filter(
          (coord) => coord.hid === coordinate.hid && coord.entrance === coordinate.entrance
        );
        const maxRankCoordinate = [
          coordinate,
          ...duplicateCoordinates,
        ].reduce((acc, curr) => (curr.rank < acc.rank ? curr : acc), coordinate);

        const isZoom100pab = zoomLevel > 16;
        const isZoom3k = zoomLevel > 13;

        const isVisible = layersVisibility[
          showPonLayer || showKtvLayer ? '' :
          maxRankCoordinate.rank === 4 && isZoom100pab ? 'icon100pab' :
          maxRankCoordinate.rank === 4 ? '' :
          maxRankCoordinate.rank === 3 && isZoom3k && maxRankCoordinate.modelSw === "Контроль питания, ранг 3" ? 'iconKp' :
          maxRankCoordinate.rank === 3 && isZoom3k ? 'icon3k' :
          maxRankCoordinate.rank === 3 ? '' :
          maxRankCoordinate.rank === 2 ? 'icon30k' :
          maxRankCoordinate.rank === 1 ? 'iconSummit' : ''
        ];

        if (!isVisible) return null;

        const hasAmplifier = ktvAmplifierData.some(
          (amp) =>
            amp.hid === coordinate.hid &&
            amp.entrance === coordinate.entrance &&
            amp.ktvAmplifierId != null
        );

        const filteredCoords = [
          ...new Map(
            [maxRankCoordinate, ...duplicateCoordinates]
              .filter((coord) => coord.ip)
              .map((coord) => [coord.ip, coord])
          ).values(),
        ];


        return (
          <Marker
            key={index}
            position={[maxRankCoordinate.latitude, maxRankCoordinate.longitude]} 
          icon={
            hasAmplifier && (maxRankCoordinate.rank === 4 || (maxRankCoordinate.rank === 3 && isZoom3k))
              ? icon3kKtv
              : (
                  maxRankCoordinate.rank === 4
                    ? icon100pab
                    : maxRankCoordinate.rank === 3 && isZoom3k
                      ? (
                          maxRankCoordinate.modelSw === "Контроль питания, ранг 3"
                            ? iconKp
                            : icon3k
                        )
                      : maxRankCoordinate.rank === 2
                        ? icon30k
                        : maxRankCoordinate.rank === 1
                          ? iconSummit
                          : null
                )
          }
            
            eventHandlers={
              !isLineDrawing
                ? { click: () => handleOpenModal(maxRankCoordinate.hid, maxRankCoordinate.entrance) }
                : {}
            }

                      >*/}
                        {/* Диалоговое окно */}
                        {/* {(openModalNode === maxRankCoordinate.hid)&&(openModalNodeEnt === maxRankCoordinate.entrance) && (
                          <DialogNodeDescroption
                          openModalNode={openModalNode}
                          openModalNodeEnt={openModalNodeEnt}
                          handleCloseModal={handleCloseModal}
                          maxRankCoordinate={maxRankCoordinate}
                          filteredCoords={filteredCoords}
                          user={user}
                          cantonRefresh={cantonRefreshNode}
                          role={role}
                          flag={CONST_CANTON}
                          cantonFobRefresh={cantonFobRefresh}
                          cantonPonBoxRefresh={cantonPonBoxRefresh}
                          />
                        )}
                      </Marker>
                    );
                  })}  */}

      {/* Не Активирование дома   */}
      {showHouses && isZoomHouse && uniqueHouses.map((house, index) => {
        {/* {showHouses && isZoomHouse && housesData.map((house, index) => { */}
      
        if (house.statusName != "Активирован") {
          return (
            
            <Marker
              key={index}
              position={[house.latitude, house.longitude]}
              icon={iconHouse}
            >
              { !isLineDrawing && (
              <Popup className='custom-popupMap2'>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img 
                  src="./house.png" 
                  width="30" 
                  height="30" 
                  style={{ marginBottom: "5px" }} 
                  alt="House"
                />
              <div>
                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                      <a href={`${SERVICE_HOUSE_URL}?Id=${house.hid}`} target="_blank" style={{ fontWeight: 'bold', color: "black" }}>
                        {house.street}, дом. {house.numberHouse}
                      </a>
                    </span>
                  
                    <br />
                    <hr className='horizontalLineFilter' />
                    <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                      ID: <span style={{ color: '#535353', fontWeight: 'normal' }}>{house.hid}</span>
                    </label> <br />
                    <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>Подъездов:<span style={{ color: '#6d0404', fontWeight: 'normal' }}> {house.entrance}</span></span>
                    <br />
                    <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                      ПАБ: <span style={{ color: '#6d0404', fontWeight: 'normal' }}>{house.apartments}</span>
                    </label> <br />
                    <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                      Статус: <span style={{ color: '#6d0404', fontWeight: 'normal' }}>{house.statusName}</span>
                    </label> <br />
                    
                  
                    <hr className='horizontalLineFilter' style={{ height: "1px" }} />
                    </div>
                    </div>
                  </Popup>
              )}
            </Marker>
        
          );
        }
        
        return null; // Не рендерим Marker, если statusName не равен "Активирован"
      })}  

{/* Активирование дома без АКТИВКИ  */}
{showHousesActivatedPassive && isZoomHouse && uniqueHouses
  .filter(house => 
    house.statusName === "Активирован" &&
    !switchesData.some(sw => sw.hid === house.hid)
  )
  .map((house, index) => (
    <Marker
      key={`active-${index}`}
      position={[house.latitude, house.longitude]}
      icon={iconHouseAct}
    >
      {!isLineDrawing && (
        <Popup className='custom-popupMap2'>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img 
              src="./house_act.png" 
              width="30" 
              height="30" 
              style={{ marginBottom: "5px" }} 
              alt="House"
            />
            <div>
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                <a href={`${SERVICE_HOUSE_URL}?Id=${house.hid}`} target="_blank" style={{ fontWeight: 'bold', color: "black"}}>
                  {house.street}, дом. {house.numberHouse}
                </a>
              </span>
              <br />
              <hr className='horizontalLineFilter' />
              <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                ID: <span style={{ color: '#535353', fontWeight: 'bold' }}>{house.hid}</span>
              </label> <br />
              <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                Подъездов:<span style={{ color: '#1b7c02', fontWeight: 'bold', textShadow: '2px 2px 4px rgb(219, 219, 219)' }}> {house.entrance}</span>
              </span>
              <br />
              <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                ПАБ: <span style={{ color: '#1b7c02', fontWeight: 'bold',textShadow: '2px 2px 4px rgb(221, 221, 221)' }}>{house.apartments}</span>
              </label> <br />
              <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                Статус: <span style={{ color: '#1b7c02', fontWeight: 'bold',textShadow: '2px 2px 4px rgb(218, 218, 218)'  }}>{house.statusName}</span>
              </label> <br />
              <hr className='horizontalLineFilter' style={{ height: "1px" }} />
            </div>
          </div>
        </Popup>
      )}
    </Marker>
))}
          </React.Fragment>
        );
      })}







      {/* {cantonTerritory && Object.keys(markersByCanton).map((canton, cantonIndex) => {
        const coordinates = markersByCanton[canton];
        const polygonPoints = getPolygonPoints(coordinates);

        return (
          <React.Fragment key={cantonIndex}>
            {polygonPoints && (
              <Polygon
              ref={el => cantonPolygonsRef.current[cantonIndex] = el}
                positions={polygonPoints}
                color={cantonPolygonColor}
                fillOpacity={showPolygonsCanton ? 0.2 : 0}
                opacity={showPolygonsCanton ? 0.6 : 0}
              >
              </Polygon>
            )}

    {coordinates.map((coordinate, index) => {
          const duplicateCoordinates = coordinates.filter((coord) =>  coord.hid === coordinate.hid && coord.entrance === coordinate.entrance);
          const maxRankCoordinate = [coordinate, ...duplicateCoordinates].reduce((acc, curr) => curr.rank < acc.rank ? curr : acc, coordinate);
 
          const isZoom100pab = zoomLevel > 16; 
          const isZoom3k = zoomLevel > 13;

          const isVisible = layersVisibility[
            maxRankCoordinate.rank === 4 && isZoom100pab ? 'icon100pab' :
            maxRankCoordinate.rank === 4 ? '' : 
            maxRankCoordinate.rank === 3 && isZoom3k && maxRankCoordinate.modelSw === "Контроль питания, ранг 3" ? 'iconKp' :
            maxRankCoordinate.rank === 3 && isZoom3k ? 'icon3k' :
            maxRankCoordinate.rank === 3 ? '' :
            maxRankCoordinate.rank === 2 ? 'icon30k' :
            maxRankCoordinate.rank === 1 ? 'iconSummit' : ''
          ];

          if (!isVisible) return null;

          const filteredCoords = [...new Map(
            [maxRankCoordinate, ...duplicateCoordinates]
              .filter(coord => coord.ip)
              .map(coord => [coord.ip, coord])
          ).values()];

          return (
            <Marker
              key={index}
              position={[maxRankCoordinate.latitude, maxRankCoordinate.longitude]}
              icon={
                maxRankCoordinate.rank === 4 && isZoom100pab ? icon100pab :
                maxRankCoordinate.rank === 3 && isZoom3k && maxRankCoordinate.modelSw === "Контроль питания, ранг 3" ? iconKp :
                maxRankCoordinate.rank === 3 && isZoom3k ? icon3k :
                maxRankCoordinate.rank === 2 ? icon30k :
                maxRankCoordinate.rank === 1 ? iconSummit :
                null
              }
            >

         


              
          {!isLineDrawing && (
           
           

           
            <Popup className="custom-popup">
              <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                <a href={`${SERVICE_HOUSE_URL}?HouseId=${maxRankCoordinate.hid}`} target="_blank" style={{ fontWeight: 'bold', color: "black" }}>
                  {maxRankCoordinate.street}, дом. {maxRankCoordinate.numberHouse}
                </a>
              </span>
              <br />
              <hr className='horizontalLineFilter' />
              <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                Подъезд:
                <span style={{ color: '#fcc205', fontWeight: 'normal' }}> {maxRankCoordinate.entrance}</span>
              </span>
              <br />
              <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>
                ID: <span style={{ color: '#fcc205', fontWeight: 'normal' }}>{maxRankCoordinate.hid}</span>
              </label>
              <Button
                style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                onClick={() => { copyToClipboard(maxRankCoordinate.hid, "Дом"); }}
              >
                <FileCopyIcon style={{ color: '#e4c253' }} />
              </Button>
              <hr className='horizontalLineFilter' style={{ height: "1px" }} />
              <button onClick={() => {openModalDescriptionComponents(maxRankCoordinate.hid);}} className='buttonIsConnectionHouseDialog'>Связи</button>
              <hr className='horizontalLineFilter' style={{ height: "1px" }} />
              {filteredCoords.length > 0 && (
                <>
                  {filteredCoords.map((coord, idx) => (
                    <React.Fragment key={idx}>
                      <div className='custom-box-pop'>
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Ранг:</span> {coord.rank} <br />
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Модель:</span> {coord.modelSw} <br />
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Мак:</span> {coord.mac} <br />
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Ip:</span>
                        <a href={`${NETSTAT_SWITCH_URL}?ip=${coord.ip}`} target="_blank" style={{ fontWeight: 'bold' }}>{coord.ip}</a>
                        <br />
                      </div>
                    </React.Fragment>
                  ))}
                </>
              )}

              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                open={snackbarOpen}
                autoHideDuration={1000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                ContentProps={{
                  style: {
                    color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                  }
                }}
              />
            

              <ModalDescriptionComponentSpecifically
                open={openModalDescription}
                onClose={closeModal}
                id={id}
                type={HOUSE}
                flag={HOUSE_FLAG}
              />
                     </Popup>
                      )}
                    </Marker>
                  );
                
                })}
                
              </React.Fragment>
            );
          })}
           */}

    
      {cantonTerritory && Object.keys(markersByVetka).map((vetka, vetkaIndex) => {
        
        const coordinates = markersByVetka[vetka];
        const polygonPoints = getPolygonPoints(coordinates);
        const vetkaPolygonColor = '#' + Math.floor(Math.random() * 16777215).toString(16); 
        return (
          <React.Fragment key={vetkaIndex}>
            {polygonPoints && (
              <Polygon
                ref={el => areaPolygonsRef.current[vetkaIndex] = el}
                positions={polygonPoints}
                color={vetkaPolygonColor} 
                fillOpacity={showPolygonsArea ? 0.2 : 0} 
                opacity={showPolygonsArea ? 0.8 : 0}
                eventHandlers={{
                  click: () => {                 
                  }
                }}
              >
                  {!(isLineDrawing || fobMarker || ponBoxMarker ||  pillarMarker || manholeMarker || couplingMarker) && showPolygonsArea &&(
                 
                  <Popup className="custom-popup">
                   <span style={{color: '#363535', fontWeight: 'bold', fontSize: '15px'}}>Ветка: </span>
                   <span style={{color: 'black', fontWeight: 'bold', fontSize: '15px'}}>{vetka}</span>
                  </Popup>
                )}
              </Polygon>              
            )}
          </React.Fragment>
        );
      })}


      {highwayTerritory && Object.keys(markersByCanton).map((vetka, vetkaIndex) => {
        const coordinates = markersByCanton[vetka];
        return (
          <React.Fragment key={vetkaIndex}>
               {coordinates.map((coordinate, index) => {
          const duplicateCoordinates = coordinates.filter((coord) =>  coord.hid === coordinate.hid && coord.entrance === coordinate.entrance);
          const maxRankCoordinate = [coordinate, ...duplicateCoordinates].reduce((acc, curr) => curr.rank < acc.rank ? curr : acc, coordinate);
          const isVisible = layersVisibility[
            maxRankCoordinate.rank === 4 ? 'icon100pab' :
            maxRankCoordinate.rank === 3 && maxRankCoordinate.modelSw === "Контроль питания, ранг 3" ? 'iconKp' :
            maxRankCoordinate.rank === 3 ? 'icon3k' :
            maxRankCoordinate.rank === 2 ? 'icon30k' :
            maxRankCoordinate.rank === 1 ? 'iconSummit' : ''
          ];
                const filteredCoords = [...new Map(
                  [maxRankCoordinate, ...duplicateCoordinates]
                    .filter(coord => coord.ip)
                    .map(coord => [coord.ip, coord])
                ).values()];
      
                if (!isVisible) return null;
                return (
                  <Marker
                    key={index}
                    position={[maxRankCoordinate.latitude, maxRankCoordinate.longitude]}
                    icon={
                      maxRankCoordinate.rank === 4 ? icon100pab :
                      maxRankCoordinate.rank === 3 && maxRankCoordinate.modelSw === "Контроль питания, ранг 3" ? iconKp :
                      maxRankCoordinate.rank === 3 ? icon3k :
                      maxRankCoordinate.rank === 2 ? icon30k :
                      maxRankCoordinate.rank === 1 ? iconSummit :
                      null
                    }
                    eventHandlers={
                      !isLineDrawing
                        ? { click: () => handleOpenModal(maxRankCoordinate.hid, maxRankCoordinate.entrance) }
                        : {}
                    }
                  >

                        {/* Диалоговое окно */}
                  {(openModalNode === maxRankCoordinate.hid)&&(openModalNodeEnt === maxRankCoordinate.entrance) && (
                    <DialogNodeDescroption
                    openModalNodeEnt={openModalNodeEnt}
                    handleCloseModal={handleCloseModal}
                    maxRankCoordinate={maxRankCoordinate}
                    filteredCoords={filteredCoords}
                    user={user}
                    cantonRefresh={highwayRefresh}
                    role={role}
                    flag={CONST_HIGHWAY}
                    />
                  )}



                    {/* {!isLineDrawing && (
                      <Popup className="custom-popup">
                      <span style={{ fontWeight: 'bold', fontSize: '14px' }}><a href={`${SERVICE_HOUSE_URL}?HouseId=${maxRankCoordinate.hid}`} target="_blank" style={{ fontWeight: 'bold', color: "black"}}>{maxRankCoordinate.street}, дом. {maxRankCoordinate.numberHouse}</a></span> <br />
                      <hr className='horizontalLineFilter' />
                        <span style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>Подъезд:<span style={{ color: '#fcc205', fontWeight: 'normal' }}> {maxRankCoordinate.entrance}</span> </span><br />
                        <label style={{ color: '#292929', fontWeight: 'bold', fontSize: '14px' }}>ID: <span style={{ color: '#fcc205', fontWeight: 'normal' }}>{maxRankCoordinate.hid}</span></label>
                        <Button
                          style={{ marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
                          onClick={() => { copyToClipboard(maxRankCoordinate.hid, "Дом"); }}>
                          <FileCopyIcon style={{ color: '#e4c253' }} />
                        </Button>
                        <hr className='horizontalLineFilter' style={{ height: "1px" }} />
                        <button onClick={() => {openModalDescriptionComponents(maxRankCoordinate.hid);}} class='buttonIsConnectionHouseDialog'>Связи</button>
                        <br />
                        <hr className='horizontalLineFilter' style={{ height: "3px" }} />

                        {filteredCoords.length > 0 && (
                          <>
                            {filteredCoords.map((coord, idx) => (
                              <React.Fragment key={idx}>
                                <div className='custom-box-pop'>
                                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Ранг:</span> {coord.rank} <br />
                                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Модель:</span> {coord.modelSw} <br />
                                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Ip:</span>
                                  <a href={`${NETSTAT_SWITCH_URL}?ip=${coord.ip}`} target="_blank" style={{ fontWeight: 'bold' }}>{coord.ip}</a>
                                  <br />
                                </div>
                              </React.Fragment>
                            ))}
                          </>
                        )}
                          <Snackbar
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                          }}
                          open={snackbarOpen}
                          autoHideDuration={1000}
                          onClose={handleCloseSnackbar}
                          message={snackbarMessage}
                          ContentProps={{
                            style: {
                              color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                            }
                          }}
                        />

                      <ModalDescriptionComponentSpecifically
                        open={openModalDescription}
                        onClose={closeModal}
                        id={id}
                        type={HOUSE}
                        flag={HOUSE_FLAG}
                      />

                      </Popup>
                    )} */}
                  </Marker>
                );
              })}
            </React.Fragment>
          );
        })}
   </>
  )
}

export default GetSwitchesMapLocation;



